Object.defineProperty(exports,"__esModule",{value:true});exports.creators=exports.default=exports.actions=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();

var _reduxOrm=require('redux-orm');
var _utils=require('./utils');function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var actions=exports.actions={
UPSERT_FLOORS:'UPSERT_FLOORS',
UPDATE_FLOORS:'UPDATE_FLOORS',
UPDATE_FLOOR:'UPDATE_FLOOR',
DELETE_FLOOR:'DELETE_FLOOR'};var





Floor=function(_Model){_inherits(Floor,_Model);function Floor(){_classCallCheck(this,Floor);return _possibleConstructorReturn(this,(Floor.__proto__||Object.getPrototypeOf(Floor)).apply(this,arguments));}_createClass(Floor,[{key:'toString',value:function toString()

























































{
return'Floor: '+this.id;
}}],[{key:'reducer',value:function reducer(action,Floor,session){if(!action)return undefined;switch(action.type){case actions.UPSERT_FLOORS:{var floors=action.payload.floors;floors.forEach(function(f){Floor.upsert(f);});break;}case actions.UPDATE_FLOORS:{var _floors=action.payload.floors;var floorsToRemove=Floor.exclude(function(floor){return _floors.find(function(_ref){var id=_ref.id;return floor.id===id;});});floorsToRemove.toModelArray().forEach(deleteRelatedChilds);floorsToRemove.delete();_floors.forEach(function(f){var floorExists=Floor.hasId(f.id);if(floorExists){var floor=Floor.withId(f.id);checkRelatedChilds(floor,f);}Floor.upsert(f);});break;}case actions.UPDATE_FLOOR:{var floor=action.payload.floor;var floorExists=Floor.hasId(floor.id);if(floorExists){var oldFloor=Floor.withId(floor.id);checkRelatedChilds(oldFloor,floor);}Floor.upsert(floor);break;}case actions.DELETE_FLOOR:{var id=action.payload.id;Floor.hasId(id)&&Floor.withId(id).delete();break;}}return undefined;}}]);return Floor;}(_reduxOrm.Model);exports.default=Floor;

Floor.modelName='Floor';

Floor.fields={
id:(0,_reduxOrm.attr)(),
name:(0,_reduxOrm.attr)(),
order:(0,_reduxOrm.attr)(),
previewImageId:(0,_reduxOrm.attr)(),
shouldDisplayBackground:(0,_reduxOrm.attr)(),
storeId:(0,_reduxOrm.fk)('Store','floorIds'),
createdAt:(0,_reduxOrm.attr)(),
updatedAt:(0,_reduxOrm.attr)(),
areasCount:(0,_reduxOrm.attr)(),
fixturesCount:(0,_reduxOrm.attr)(),
positionsCount:(0,_reduxOrm.attr)(),
layoutPositionId:(0,_reduxOrm.oneToOne)('LayoutPosition','floorId'),
areas:(0,_reduxOrm.attr)(),
fixtures:(0,_reduxOrm.attr)()};


var upsertFloors=function upsertFloors(floors){
var objs=floors?
floors.map(function(f){
var floor=_extends({},
f,{
areas:f.areaIds,
fixtures:f.fixtureIds});

return(0,_utils.filterInput)(Floor)(floor);
}):
[];

return{
type:actions.UPSERT_FLOORS,
payload:{
floors:objs}};


};

var updateFloors=function updateFloors(floors){
var objs=floors?
floors.map(function(f){
var floor=_extends({},
f,{
areas:f.areaIds,
fixtures:f.fixtureIds});

return(0,_utils.filterInput)(Floor)(floor);
}):
[];

return{
type:actions.UPDATE_FLOORS,
payload:{
floors:objs}};


};

var updateFloor=function updateFloor(floor){
if(!floor)return;

var filteredFloor=(0,_utils.filterInput)(Floor)(_extends({},
floor,{
areas:floor.areaIds,
fixtures:floor.fixtureIds}));


return{
type:actions.UPDATE_FLOOR,
payload:{
floor:filteredFloor}};


};

var deleteFloorWithId=function deleteFloorWithId(id){return{
type:actions.DELETE_FLOOR,
payload:{
id:id}};};



var creators=exports.creators={
upsertFloors:upsertFloors,
updateFloors:updateFloors,
updateFloor:updateFloor,
deleteFloorWithId:deleteFloorWithId};


var checkRelatedChilds=function checkRelatedChilds(oldFloor,newFloor){
checkRelationshipsToAreasAndDeleteOld(oldFloor,newFloor);
checkRelationshipsToFixturesAndDeleteOld(oldFloor,newFloor);
};

var checkRelationshipsToAreasAndDeleteOld=function checkRelationshipsToAreasAndDeleteOld(oldFloor,newFloor){
var existingAreasForFloor=oldFloor.areaIds;
var newAreaIds=newFloor.areas;

if(!existingAreasForFloor){
return;
}

if(!newAreaIds){
existingAreasForFloor.delete();
return;
}

existingAreasForFloor.filter(function(area){return!newAreaIds.includes(area.id);}).delete();
};

var checkRelationshipsToFixturesAndDeleteOld=function checkRelationshipsToFixturesAndDeleteOld(oldFloor,newFloor){
var existingFixturesForFloor=oldFloor.fixtureIds;
var newFixtureIds=newFloor.fixtures;

if(!existingFixturesForFloor){
return;
}

if(!newFixtureIds){
existingFixturesForFloor.delete();
return;
}

existingFixturesForFloor.
filter(function(fixture){return!newFixtureIds.includes(fixture.id);}).
delete();
};

var deleteRelatedChilds=function deleteRelatedChilds(floor){
floor.areaIds&&floor.areaIds.delete();
floor.fixtureIds&&floor.fixtureIds.delete();
};